import { render, staticRenderFns } from "./FileTree.vue?vue&type=template&id=1ed2e0da&scoped=true&"
import script from "../../../sl-vue-tree?vue&type=script&lang=js&"
export * from "../../../sl-vue-tree?vue&type=script&lang=js&"
import style0 from "./FileTree.vue?vue&type=style&index=0&id=1ed2e0da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed2e0da",
  null
  
)

export default component.exports